import { PropertyHelper } from "@/helpers/property.helper";
import { MapParcelle } from "@/modules/map/interfaces/mapParcelle.interface";
import { NgFor, NgIf } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormArray,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { LandRegistry, Location } from "@eemo/api-client";
import { Subject } from "rxjs";
import { MapModule } from "../../modules/map/map.module";
import { RealPropertyMutable } from "../property-add-full-dialog/property-add-full-dialog.component";
import { InputComponent } from "../ui-forms/input/input.component";

export interface ExtendedLandRegistry extends LandRegistry {
  id: string;
}

@Component({
  selector: "app-property-add-location",
  templateUrl: "./property-add-location.component.html",
  styleUrls: ["./property-add-location.component.scss"],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatChipsModule,
    NgFor,
    MatIconModule,
    NgIf,
    MatFormFieldModule,
    MapModule,
    InputComponent,
  ],
})
export class PropertyAddLocationComponent implements OnInit {
  @Input() prop: RealPropertyMutable;
  @Output() propertyUpdated = new EventEmitter<RealPropertyMutable>();

  parcelleUnselectedSubject$ = new Subject<string>();
  parcelleUnselected$ = this.parcelleUnselectedSubject$.asObservable();

  formSubmitting = false;
  formSubmitted = false;

  landRegistriesName = [];

  get form_latitude() {
    return this.form.get("latitude") as FormControl<number>;
  }

  get form_longitude() {
    return this.form.get("longitude") as FormControl<number>;
  }

  get form_landRegistries() {
    return this.form.get("landRegistries") as FormArray;
  }

  form = this.fb.group({
    latitude: [null, Validators.required],
    longitude: [null, Validators.required],
    landRegistries: this.fb.array([], [Validators.required]),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private propHelper: PropertyHelper
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.form_latitude.setValue(this.prop.location.latitude);
    this.form_longitude.setValue(this.prop.location.longitude);
  }

  addLandRegistry(registry: ExtendedLandRegistry) {
    this.form_landRegistries.push(
      new FormControl(registry, Validators.required)
    );
    this.landRegistriesName.push(
      this.propHelper.getLandRegistryDisplayName(registry)
    );
  }

  removeLandRegistry(index: number) {
    if (!this.form_landRegistries.at(index)) return;
    const removed = this.form_landRegistries.at(index).value;
    this.form_landRegistries.removeAt(index);
    this.landRegistriesName.splice(index, 1);
    this.parcelleUnselectedSubject$.next(removed.id);
  }

  mapLocationUpdated(event: Location) {
    this.form_latitude.setValue(event.latitude);
    this.form_longitude.setValue(event.longitude);
  }

  mapParcelleSelected(event: MapParcelle) {
    this.addLandRegistry({
      id: event.id,
      plot: event.numero,
      section: event.section,
      prefix: event.prefixe,
      inseeCode: event.commune,
      surface: event.contenance,
    });
  }

  mapParcelleUnSelected(event: MapParcelle) {
    const index = this.form_landRegistries
      .getRawValue()
      .findIndex((r) => r.id === event.id);
    this.removeLandRegistry(index);
  }

  onSubmit() {
    if (this.form.valid) {
      this.formSubmitting = true;
      this.prop.location.latitude = this.form_latitude.value;
      this.prop.location.longitude = this.form_longitude.value;
      this.prop.landRegistry = this.form_landRegistries.at(0).value;
      this.prop.otherLandRegistries = [];
      if (this.form_landRegistries.length > 1) {
        for (let i = 1; i < this.form_landRegistries.length; i++) {
          this.prop.otherLandRegistries.push(
            this.form_landRegistries.at(i).value
          );
        }
      }
      this.propertyUpdated.emit(this.prop);
      this.formSubmitting = false;
    }
  }
}
